import { useRef } from "react";
import "./FreeSoloDropdownInput.styles.scss";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const FreeSoloDropdownInput = ({
  name,
  label,
  options,
  value,
  onChange,
  containerClassNames,
  labelClassNames,
  disabled,
}: {
  name?: string;
  label?: string;
  options: { label: string; value: string }[];
  value?: string;
  onChange: (value: any, name: any) => void;
  containerClassNames: string;
  labelClassNames: string;
  disabled?: boolean;
}) => {
  const autoCompleteRef = useRef<HTMLInputElement | null>(null);

  // When value is a plain string, resolve it to the matching option so the
  // Autocomplete displays the formatted label rather than the raw value.
  const resolvedValue =
    typeof value === "string"
      ? options.find((o) => o.value === value) ?? value
      : value;

  const handleChange = (
    _: React.SyntheticEvent,
    newValue: any,
    reason: string
  ) => {
    if (reason === "selectOption" || reason === "createOption") {
      onChange(
        reason === "createOption" ? newValue.toUpperCase() : newValue.value,
        name
      );
      if (autoCompleteRef.current) {
        autoCompleteRef.current.blur();
      }
    } else if (reason === "clear") {
      onChange("", name);
    }
  };

  return (
    <div className={containerClassNames}>
      <p className={`${labelClassNames} free-solo-dropdown-input-label`}>
        {label}
      </p>
      <Autocomplete
        options={options}
        freeSolo
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option.label
        }
        renderOption={(props, option) => (
          <li
            {...props}
            key={typeof option === "string" ? option : option.value}
          >
            {typeof option === "string" ? option : option.label}
          </li>
        )}
        value={resolvedValue}
        onChange={handleChange as any}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="filled"
            placeholder="Select items"
            inputRef={(input) => {
              autoCompleteRef.current = input;
            }}
            sx={{
              backgroundColor: "#0c1835",
              "& .MuiFilledInput-root": {
                paddingTop: "0.5rem",
                paddingBottom: "0.5rem",
              },
              "& input": {
                color: "rgb(232, 234, 239)",
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "rgb(147, 157, 182)",
              },
              "& .MuiAutocomplete-clearIndicator": {
                color: "#b6bdce",
                "&:hover": {
                  color: "#ffffff",
                },
              },
            }}
          />
        )}
      />
    </div>
  );
};

export default FreeSoloDropdownInput;
